<template>
  <router-link v-if="page !== '/'" to="/">
    <div class="bg-innerPage-header h-32 w-full lg:h-48">
      <div class="logo-detran-cidadao"></div>
    </div>
  </router-link>

  <slot></slot>

  <div class="w-full bg-yellow-50 bg-opacity-70">
    <div class="container flex gap-4 px-4 pt-4 lg:px-8">
      <div
        v-for="tab in years"
        :key="tab"
        :id="`tab-${tab}`"
        :class="{ active: activeTab === tab }"
        @click="activeTab = tab"
        class="flex-grow cursor-pointer rounded-t-md px-4 py-2 text-2xl text-gray-600 lg:flex-grow-0 lg:px-16 lg:py-3">
        <h2 class="text-center">{{ tab }}</h2>
      </div>
    </div>

    <div class="w-full">
      <div v-show="activeTab === 2022" class="w-full bg-green-800 bg-opacity-90 py-4">
        <div
          class="container flex h-auto w-full flex-row justify-between gap-3 px-4 py-3 lg:grid lg:grid-cols-7 lg:flex-wrap lg:px-8">
          <router-link
            v-for="(link, index) in links[2022]"
            :key="index"
            :to="link.to"
            class="hidden items-center justify-start lg:flex"
            @click="trackClick('Menu', `Menu - ${link.label} - 2022`)"
            style="max-width: 10rem">
            <button class="w-full rounded-full bg-yellow-400 py-2 hover:bg-yellow-500">
              <span class="font-bold uppercase text-gray-800">
                {{ link.label }}
              </span>
            </button>
          </router-link>

          <button
            :value="getPages(page).prev"
            class="basis-0 my-2 rounded-full bg-yellow-400 py-2 hover:bg-yellow-500 lg:hidden"
            style="flex-basis: 16.666667%"
            @click="changeRoute($event)">
            <svg class="mx-auto h-6 w-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path
                clip-rule="evenodd"
                d="M18 10a.75.75 0 01-.75.75H4.612l5.158 4.96a.75.75 0 11-1.04 1.08l-6.5-6.25a.75.75 0 010-1.08l6.5-6.25a.75.75 0 111.04 1.08L4.612 9.25H17.25A.75.75 0 0118 10z"
                fill-rule="evenodd" />
            </svg>
          </button>

          <select
            :value="page"
            class="my-2 flex appearance-none justify-center rounded-full border-none bg-yellow-500 py-2 text-center font-bold shadow-sm transition ease-in-out focus:border-yellow-400 focus:ring focus:ring-yellow-400 focus:ring-opacity-50 lg:hidden"
            style="flex-basis: 66.666667%"
            @change="changeRoute($event)">
            <option v-if="!isInYear(2022, page)" disabled :value="page">Selecione uma fase</option>
            <option v-for="(link, index) in links[2022]" :key="index" :value="link.to">
              {{ link.label }}
            </option>
          </select>

          <button
            :value="getPages(page).next"
            class="my-2 block w-16 rounded-full bg-yellow-400 py-2 hover:bg-yellow-500 lg:hidden"
            style="flex-basis: 16.666667%"
            @click="changeRoute($event)">
            <svg class="mx-auto h-6 w-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path
                clip-rule="evenodd"
                d="M2 10a.75.75 0 01.75-.75h12.638L10.23 4.29a.75.75 0 111.04-1.08l6.5 6.25a.75.75 0 010 1.08l-6.5 6.25a.75.75 0 11-1.04-1.08l5.158-4.96H2.75A.75.75 0 012 10z"
                fill-rule="evenodd" />
            </svg>
          </button>
        </div>
      </div>
      <div v-show="activeTab === 2023" class="w-full bg-green-800 bg-opacity-90 py-4">
        <div
          class="container flex h-auto w-full flex-row justify-between gap-3 px-4 py-3 lg:grid lg:grid-cols-7 lg:flex-wrap lg:px-8">
          <router-link
            v-for="(link, index) in links[2023]"
            :key="index"
            :to="link.to"
            class="hidden items-center justify-start lg:flex"
            @click="trackClick('Menu', `Menu ${link.label} - 2023`)"
            style="max-width: 10rem">
            <button class="w-full rounded-full bg-yellow-400 py-2 hover:bg-yellow-500">
              <span class="font-bold uppercase text-gray-800">
                {{ link.label }}
              </span>
            </button>
          </router-link>

          <button
            :value="getPages(page).prev"
            class="basis-0 my-2 rounded-full bg-yellow-400 py-2 hover:bg-yellow-500 lg:hidden"
            style="flex-basis: 16.666667%"
            @click="changeRoute($event)">
            <svg class="mx-auto h-6 w-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path
                clip-rule="evenodd"
                d="M18 10a.75.75 0 01-.75.75H4.612l5.158 4.96a.75.75 0 11-1.04 1.08l-6.5-6.25a.75.75 0 010-1.08l6.5-6.25a.75.75 0 111.04 1.08L4.612 9.25H17.25A.75.75 0 0118 10z"
                fill-rule="evenodd" />
            </svg>
          </button>

          <select
            :value="page"
            class="my-2 flex appearance-none justify-center rounded-full border-none bg-yellow-500 py-2 text-center font-bold shadow-sm transition ease-in-out focus:border-yellow-400 focus:ring focus:ring-yellow-400 focus:ring-opacity-50 lg:hidden"
            style="flex-basis: 66.666667%"
            @change="changeRoute($event)">
            <option v-if="!isInYear(2023, page)" disabled :value="page">Selecione uma fase</option>
            <option v-for="(link, index) in links[2023]" :key="index" :value="link.to">
              {{ link.label }}
            </option>
          </select>

          <button
            :value="getPages(page).next"
            class="my-2 block w-16 rounded-full bg-yellow-400 py-2 hover:bg-yellow-500 lg:hidden"
            style="flex-basis: 16.666667%"
            @click="changeRoute($event)">
            <svg class="mx-auto h-6 w-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path
                clip-rule="evenodd"
                d="M2 10a.75.75 0 01.75-.75h12.638L10.23 4.29a.75.75 0 111.04-1.08l6.5 6.25a.75.75 0 010 1.08l-6.5 6.25a.75.75 0 11-1.04-1.08l5.158-4.96H2.75A.75.75 0 012 10z"
                fill-rule="evenodd" />
            </svg>
          </button>
        </div>
      </div>
      <div v-show="activeTab === 2024" class="w-full bg-green-800 bg-opacity-90 py-4">
        <div
          class="container flex h-auto w-full flex-row justify-between gap-3 px-4 py-3 lg:grid lg:grid-cols-7 lg:flex-wrap lg:px-8">
          <router-link
            v-for="(link, index) in links[2024]"
            :key="index"
            :to="link.to"
            class="hidden items-center justify-start lg:flex"
            @click="trackClick('Menu', `Menu ${link.label} - 2024`)"
            style="max-width: 10rem">
            <button class="w-full rounded-full bg-yellow-400 py-2 hover:bg-yellow-500">
              <span class="font-bold uppercase text-gray-800">
                {{ link.label }}
              </span>
            </button>
          </router-link>

          <button
            :value="getPages(page).prev"
            class="basis-0 my-2 rounded-full bg-yellow-400 py-2 hover:bg-yellow-500 lg:hidden"
            style="flex-basis: 16.666667%"
            @click="changeRoute($event)">
            <svg class="mx-auto h-6 w-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path
                clip-rule="evenodd"
                d="M18 10a.75.75 0 01-.75.75H4.612l5.158 4.96a.75.75 0 11-1.04 1.08l-6.5-6.25a.75.75 0 010-1.08l6.5-6.25a.75.75 0 111.04 1.08L4.612 9.25H17.25A.75.75 0 0118 10z"
                fill-rule="evenodd" />
            </svg>
          </button>

          <select
            :value="page"
            class="my-2 flex appearance-none justify-center rounded-full border-none bg-yellow-500 py-2 text-center font-bold shadow-sm transition ease-in-out focus:border-yellow-400 focus:ring focus:ring-yellow-400 focus:ring-opacity-50 lg:hidden"
            style="flex-basis: 66.666667%"
            @change="changeRoute($event)">
            <option v-if="!isInYear(2024, page)" disabled :value="page">Selecione uma fase</option>
            <option v-for="(link, index) in links[2024]" :key="index" :value="link.to">
              {{ link.label }}
            </option>
          </select>

          <button
            :value="getPages(page).next"
            class="my-2 block w-16 rounded-full bg-yellow-400 py-2 hover:bg-yellow-500 lg:hidden"
            style="flex-basis: 16.666667%"
            @click="changeRoute($event)">
            <svg class="mx-auto h-6 w-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path
                clip-rule="evenodd"
                d="M2 10a.75.75 0 01.75-.75h12.638L10.23 4.29a.75.75 0 111.04-1.08l6.5 6.25a.75.75 0 010 1.08l-6.5 6.25a.75.75 0 11-1.04-1.08l5.158-4.96H2.75A.75.75 0 012 10z"
                fill-rule="evenodd" />
            </svg>
          </button>
        </div>
      </div>
      <div v-if="mostrar_fase_2025" v-show="activeTab === 2025" class="w-full bg-blue-800 bg-opacity-90 py-4">
        <div
            class="container flex h-auto w-full flex-row justify-between gap-3 px-4 py-3 lg:grid lg:grid-cols-7 lg:flex-wrap lg:px-8">
          <router-link
              v-for="(link, index) in links[2025]"
              :key="index"
              :to="link.to"
              class="hidden items-center justify-start lg:flex"
              @click="trackClick('Menu', `Menu ${link.label} - 2025`)"
              style="max-width: 10rem">
            <button class="w-full rounded-full bg-yellow-400 py-2 hover:bg-yellow-500">
              <span class="font-bold uppercase text-gray-800">
                {{ link.label }}
              </span>
            </button>
          </router-link>

          <button
              :value="getPages(page).prev"
              class="basis-0 my-2 rounded-full bg-yellow-400 py-2 hover:bg-yellow-500 lg:hidden"
              style="flex-basis: 16.666667%"
              @click="changeRoute($event)">
            <svg class="mx-auto h-6 w-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path
                  clip-rule="evenodd"
                  d="M18 10a.75.75 0 01-.75.75H4.612l5.158 4.96a.75.75 0 11-1.04 1.08l-6.5-6.25a.75.75 0 010-1.08l6.5-6.25a.75.75 0 111.04 1.08L4.612 9.25H17.25A.75.75 0 0118 10z"
                  fill-rule="evenodd" />
            </svg>
          </button>

          <select
              :value="page"
              class="my-2 flex appearance-none justify-center rounded-full border-none bg-yellow-500 py-2 text-center font-bold shadow-sm transition ease-in-out focus:border-yellow-400 focus:ring focus:ring-yellow-400 focus:ring-opacity-50 lg:hidden"
              style="flex-basis: 66.666667%"
              @change="changeRoute($event)">
            <option v-if="!isInYear(2025, page)" disabled :value="page">Selecione uma fase</option>
            <option v-for="(link, index) in links[2025]" :key="index" :value="link.to">
              {{ link.label }}
            </option>
          </select>

          <button
              :value="getPages(page).next"
              class="my-2 block w-16 rounded-full bg-yellow-400 py-2 hover:bg-yellow-500 lg:hidden"
              style="flex-basis: 16.666667%"
              @click="changeRoute($event)">
            <svg class="mx-auto h-6 w-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path
                  clip-rule="evenodd"
                  d="M2 10a.75.75 0 01.75-.75h12.638L10.23 4.29a.75.75 0 111.04-1.08l6.5 6.25a.75.75 0 010 1.08l-6.5 6.25a.75.75 0 11-1.04-1.08l5.158-4.96H2.75A.75.75 0 012 10z"
                  fill-rule="evenodd" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import util from '@/util';

export default defineComponent({
  name: 'Menu',
  setup() {
    const inscricoes_ativas = computed(() => util.get_inscricoes_ativas());
    const mostrar_nova_fase = computed(() => util.get_mostrar_nova_fase());
    const mostrar_fase_2025 = computed(() => util.get_mostrar_fase_2025());
    const trackClick = util.trackClick;
    return { inscricoes_ativas, trackClick, mostrar_nova_fase, mostrar_fase_2025 };
  },
  data: function () {
    let activeTab = 2024;
    let years = [2024, 2023, 2022];
    const links: { [key: number]: { to: string; label: string }[] } = {
      2022: [
        { to: '/selecionados-primeira-fase-cnh', label: '1ª Fase' },
        { to: '/selecionados-segunda-fase-cnh', label: '2ª Fase' },
        { to: '/selecionados-terceira-fase-cnh', label: '3ª Fase' },
        { to: '/selecionados-quarta-fase-cnh', label: '4ª Fase' },
        { to: '/selecionados-quinta-fase-cnh', label: '5ª Fase' },
        { to: '/selecionados-sexta-fase-cnh', label: '6ª Fase' },
        { to: '/selecionados-setima-fase-cnh', label: '7ª Fase' },
      ],
      2023: [{ to: '/selecionados-primeira-fase-cnh-2023', label: '1ª Fase' }],
      2024: [{ to: '/selecionados-primeira-fase-cnh-2024', label: '1ª Fase' }],
      2025: [
          { to: '/selecionados-primeira-fase-cnh-2025', label: '1ª Fase' },
          { to: '/selecionados-segunda-fase-cnh-2025', label: '2ª Fase' }
      ]
    };

    if (this.mostrar_nova_fase) {
      // links[2024] = [{ to: '/selecionados-primeira-fase-cnh-2024', label: '1ª Fase' }];
      // activeTab = 2024;
      // years.unshift(2024);
    }

    // Show 2025 content only when timer allows it
    if (this.mostrar_fase_2025) {
      years.unshift(2025);
      activeTab = 2025;
    }

    return {
      page: '/',
      links: links,
      activeTab,
      years,
    };
  },
  created() {
    this.page = this.$route.path;
    const date: { [year: number]: { to: string; label: string }[] } = this.links;
    for (const year in date) {
      if (this.isInYear(parseInt(year), this.page)) {
        this.activeTab = parseInt(year);
      }
    }
  },
  methods: {
    isInYear(year: number, searchString: string): boolean {
      const date: { [year: number]: { to: string; label: string }[] } = this.links;
      const years = date[year];
      if (years) {
        return years.some((obj) => obj.to === searchString);
      }
      return false;
    },
    changeRoute(event: Event) {
      const target = (event.currentTarget as HTMLTextAreaElement).value;
      (this.trackClick as (category: string, label: string) => void)('Menu', `Menu - ${this.getPages(target).label}`);
      this.$router.push(target ? target : '/');
    },
    getPages(page: string, year = 2022): { label: string; prev: string; next: string } {
      const date: { [year: number]: { to: string; label: string }[] } = this.links;
      const index = date[year].findIndex((link) => link.to === page);
      if (index > -1) {
        return {
          label: date[year][index].label,
          prev: date[year][index === 0 ? date[year].length - 1 : index - 1].to,
          next: date[year][index === date[year].length - 1 ? 0 : index + 1].to,
        };
      }
      return { label: '', prev: page, next: page };
    },
  },
});
</script>

<style scoped>
.active {
  @apply text-white;
}

#tab-2022.active {
  @apply bg-green-800 bg-opacity-90;
}

#tab-2023.active {
  @apply bg-green-800 bg-opacity-90;
}

#tab-2024.active {
  @apply bg-green-800 bg-opacity-90;
}

#tab-2025.active {
  @apply bg-blue-800 bg-opacity-90;
}
</style>
